import { render, staticRenderFns } from "./customer-card.vue?vue&type=template&id=e0a3d2c2&scoped=true&lang=pug&"
import script from "./customer-card.vue?vue&type=script&lang=js&"
export * from "./customer-card.vue?vue&type=script&lang=js&"
import style0 from "./customer-card.vue?vue&type=style&index=0&id=e0a3d2c2&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0a3d2c2",
  null
  
)

export default component.exports